import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/settings/security")({
	beforeLoad: () => {
		throw redirect({ to: "/settings/account", hash: "security" });
	},
});
